<template>
  <div
    ref="appRef"
    :class="{
      container: true,
      allBg: page == 'about',
      downBg: page == 'download' && appWith,
    }"
  >
    <navigationBar
      :curPage="curPage"
      @changeType="changeType"
      @changePage="changePage"
    ></navigationBar>
    <!-- <div class="round-triangle"></div> -->
    <router-view></router-view>
    <!-- <home-vue v-if="page == 'home'"></home-vue>
    <product-comp v-if="page == 'product'"></product-comp>
    <download-comp v-if="page == 'download'"></download-comp>
    <about-comp v-if="page == 'about'"></about-comp> -->
    <footerComp :curPage="curPage" @changePage="changePage"></footerComp>
    <Transition>
      <div class="pop" v-show="isShowMobDiaolg">
        <div class="pop-content">
          <img
            class="close"
            src="./static/images/close.png"
            alt=""
            @click="isShowMobDiaolg = false"
          />
          <div class="navigate" v-show="mobType == 'navigate'">
            <div
              :class="{ 'nav-item': true, fontBlod: curPage == '' }"
              @click="changePage('', 'mob')"
            >
              首页
            </div>
            <div
              :class="{ 'nav-item': true, fontBlod: curPage == 'product' }"
              @click="changePage('product', 'mob')"
            >
              产品介绍
            </div>
            <div
              :class="{ 'nav-item': true, fontBlod: curPage == 'download' }"
              @click="changePage('download', 'mob')"
            >
              产品下载
            </div>
            <div
              :class="{ 'nav-item': true, fontBlod: curPage == 'about' }"
              @click="changePage('about', 'mob')"
            >
              关于我们
            </div>
          </div>
          <div class="weixin" v-show="mobType == 'weixin'">
            <img src="./static/images/concatCode.png" alt="" />
            <div class="text">扫码添加微信</div>
          </div>
          <div class="concat" v-show="mobType == 'concat'">
            <img src="./static/images/qrcode.jpg" alt="" />
            <div class="text">扫码关注公众号</div>
          </div>
          <div class="mini" v-show="mobType == 'mini'">
            <img src="./static/images/miniCode.jpg" alt="" />
            <div class="text">扫码进入小程序</div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import navigationBar from "@/components/navigationBar.vue";
// import homeVue from "./pages/homeVue.vue";
// import productComp from "./pages/productComp.vue";
// import aboutComp from "./pages/aboutComp.vue";
// import downloadComp from "@/pages/downloadComp.vue";
import footerComp from "@/components/footerComp.vue";
import { useRouter } from "vue-router";

const isShowMobDiaolg = ref(false);
const mobType = ref("navigate");
const page = ref("");
const curPage = ref("");
const appRef = ref();
const router = useRouter();
let appWith = ref(false);

onMounted(() => {
  appWith = appRef.value.offsetWidth <= 840 ? false : true;
});
// 接收导航栏点击事件
const changeType = (type) => {
  mobType.value = type;
  isShowMobDiaolg.value = true;
};
// PC点击导航栏
const changePage = (page1, type) => {
  if (type) {
    isShowMobDiaolg.value = false;
  }
  curPage.value = page1;
  // page.value = page1;
  router.push(`/${page1}`);
};
</script>

<style lang="scss">
.allBg {
  background-image: url("./static/images/bg.png") !important;
  background-size: 100vw !important;
  background-repeat: no-repeat !important;
}
.downBg {
  background-image: url("./static/images/bg-down.png") !important;
  background-size: 100vw !important;
  background-repeat: no-repeat !important;
}
.container {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  background: #f2f9ff;
  > .content {
    position: relative;
  }
  > .pop {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    .fontBlod {
      font-weight: bold;
    }
    .pop-content {
      width: 100%;
      height: 150px;
      padding: 40px 0 20px 0;
      background-color: #fff;
      border-radius: 0 0 10px 10px;
      text-align: center;
      position: relative;
      .close {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 16px;
        left: 16px;
      }
      .navigate {
        text-align: center;
        .nav-item {
          height: 32px;
          line-height: 32px;
          font-size: 16px;
        }
      }
      .weixin,
      .concat,
      .mini {
        > img {
          width: 120px;
          height: 120px;
        }
        .text {
          font-size: 14px;
        }
      }
    }
  }
  // 移动端pop过度
  // .v-enter-active,
  // .v-leave-active {
  //   transition: transform 0.5s ease;
  //   transform: translateY(0);
  // }

  // .v-enter-from,
  // .v-leave-to {
  //   transform: translateY(-100vh);
  // }
  > .pcPop {
    position: abs($number: 0);
    top: 10px;
    right: 20px;
    .pcPop-content {
      width: 104px;
      height: 104px;
      background-color: #fff;
      border-radius: 10px;
      text-align: center;
      > img {
        width: 80px;
        height: 80px;
        margin-bottom: 5px;
      }
      .pcPop-text {
        font-size: 10px;
      }
    }
  }
}
</style>
